import { useLanguage } from "@/stores/useLangStore";
import { Box, Button, Typography } from "@mui/material";
import Image from "next/image";

const texts = {
  en: {
    title: "Filter, Compare, And Select The Best Medical University For You",
    btnLabel: "Get started on your journey",
  },
  jp: {
    title: "検索条件、比較、最適な大学の選択",
    btnLabel: "あなたの旅を始める",
  },
};

const EndPostComponent = () => {
  const { lang } = useLanguage();
  return (
    <Box
      sx={{
        py: (theme) => theme.customLayout.py,
        px: (theme) => theme.customLayout.px,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#004238",
          padding: "90px",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "48px",
            lineHeight: "56px",
            fontWeight: 700,
            letterSpacing: "-0.03em",
            textAlign: "center",
            color: "#fff",
            textUnderlinePosition: "from-font",
            textDecorationDkipInk: "none",
          }}
        >
          {texts[lang].title}
        </Typography>

        <Button
          component={"a"}
          href="/filter-university"
          sx={{
            background: "#101828",
            color: "#FFFFFF",
            fontSize: "16px",
            lineHeight: "20px",
            fontWeight: 700,
            padding: "12px 20px",
            borderRadius: "25px",
            textTransform: "none",
            marginTop: "20px",
            "&:hover": {
              cursor: "pointer",
              opacity: 0.8,
            },
          }}
        >
          <span style={{ marginRight: "8px" }}>{texts[lang].btnLabel}</span>
          <Image
            src="/assets/common/ArrowRight.png"
            alt={`NextArrow`}
            width={5}
            height={10}
          />
        </Button>
      </Box>
    </Box>
  );
};

export default EndPostComponent;
